<mat-card class="bg-light">
    <div class="container-fluid marginHeader" *ngIf="!loadingBatch">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Data</strong></label>
                    <span class="form-text"> {{ journal.date | date: 'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Tipo de Lote</strong></label>
                    <span class="form-text"> {{ 'JournalType.' + journal.journalType | translate }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Nº Itens</strong></label>
                    <span class="form-text"> {{ journal.countItens }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Mês/Ano Contábil</strong></label>
                    <span class="form-text"> {{ journal.accountMonthDate | date: 'MM/yyyy' }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Nome de Usuário</strong></label>
                    <span class="form-text"> {{ journal.username }}</span>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label class="form-text"><strong>Número</strong></label>
                    <span class="form-text"> {{ journal.number ? journal.number : '-' }}</span>
                </div>
            </div>

            <div class="alight" *ngIf="journal.journalStatus != 'Success'">
                <button [disabled]="loaderService.isLoading | async" type="button" class="btn btn-primary mr-2"
                    (click)="reSendBatch()">
                    {{ journal.journalStatus === '0' ? 'Exportar' : 'Reenviar' }} Lote
                </button>
            </div>

        </div>
    </div>

    <div class="col text-right">
        <div class="margin-lr-5">
            <mat-icon class="btnRefresh" (click)="refresh()">refresh</mat-icon>
        </div>
        <!-- <button (click)="attachments()" type="button" class="btn btn-light px-5">
            <div style="font-size: 30px;"> 📂 </div>
            Anexos
        </button> -->
    </div>

    <div class="container-fluid marginHeader" *ngIf="loadingBatch">
        <div class="row">
            <div class="col" *ngFor="let i of [1,2,3,4,5,6]">
                <div class="form-group">
                    <div class="skeleton-box"></div>
                </div>
            </div>
        </div>
    </div>
</mat-card>

<mat-card class="mt-2 mb-4">

    <mat-tab-group mat-align-tabs="start" dynamicHeight>
        <mat-tab label="Itens do Lote">
            <ngb-alert [dismissible]="false" type="danger" *ngIf="journal?.errors?.length > 0">
                <p>Erros</p>
                <div *ngFor="let item of journal.errors">
                    <div *ngIf="journal.dracmaLotId">
                        {{ parseError(item) }}
                    </div>
                    <div *ngIf="!journal.dracmaLotId">
                        {{ 'JournalErrors.' + item.message | translate }} : {{ item.detail }}
                    </div>
                </div>
            </ngb-alert>
            <!-- Loading skeleton -->
            <div class="example-headers-align" *ngIf="loadingItens">
                <div class="loading-rows">
                    <div class="row rowCardCustom loading-skeleton" *ngFor="let i of [1,2,3,4,5]">
                        <div class="col-3">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-1">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-1">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-1">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-3">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-1">
                            <div class="skeleton-box"></div>
                        </div>
                        <div class="col-1">
                            <div class="skeleton-box"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Actual content -->
            <div class="example-headers-align" *ngIf="!loadingItens && journalItensOriginal.length > 0">
                <div class="row">
                    <div class="col-2">
                        <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                            <mat-label>Conta</mat-label>
                            <input matInput [(ngModel)]="accountFilter" (keyup.enter)="filterAccountSucAccount()" />
                        </mat-form-field>
                    </div>
                    <div class="col-2">
                        <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                            <mat-label>Sub Conta</mat-label>
                            <input matInput [(ngModel)]="subAccountFilter" (keyup.enter)="filterAccountSucAccount()" />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <button (click)="filterAccountSucAccount()" class="btn btn-primary mr-2">
                            <i class="flaticon2-search"></i>Filtrar
                        </button>
                    </div>
                    <div class="col-2 text-center" style="position: fixed; right: 0; z-index: 99999">
                        <button (click)="updateAllJournalItem()" class="btn btn-success pl-5 pr-5">
                            Salvar <i class="fa fa-save"></i>
                        </button>
                    </div>
                </div>
                <!-- Actual rows -->
                <div *ngIf="!loadingRows">
                    <div class="row rowCardCustom" *ngFor="let item of sortableItens; let i = index">
                        <div class="col-12">
                            <ng-template #htmlContentTooltipErrorDescription>
                                <span *ngIf="!item.isSuccess">
                                    {{ 'JournalErrors.' + item.errorDescription | translate }}
                                </span>
                                <span *ngIf="item.isSuccess">Sucesso</span>
                            </ng-template>
                        </div>
                        <div class="col-3">
                            <div class="row">
                                <div class="col-1 mat-custom">
                                    <span class="item-row-number">{{ i + 1 }}</span>
                                </div>
                                <div class="col-5">
                                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'"
                                        appearance="outline">
                                        <mat-label>Conta</mat-label>
                                        <input matInput [(ngModel)]="item.accountCode" />
                                    </mat-form-field>
                                </div>
                                <div class="col-5">
                                    <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'"
                                        appearance="outline">
                                        <mat-label>Sub Conta</mat-label>
                                        <input matInput [(ngModel)]="item.subAccount" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">
                            <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                                <mat-label>Departamento</mat-label>
                                <input matInput [(ngModel)]="item.departmentCode" />
                            </mat-form-field>
                        </div>
                        <div class="col-1">
                            <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                                <mat-label>Fundo</mat-label>
                                <input matInput [(ngModel)]="item.fundCode" />
                            </mat-form-field>
                        </div>
                        <div class="col-1">
                            <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                                <mat-label>Restrição</mat-label>
                                <input matInput [(ngModel)]="item.restrictionCode" />
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="outline">
                                <mat-label>Descrição do Item:</mat-label>
                                <input matInput [(ngModel)]="item.description" />
                            </mat-form-field>
                        </div>
                        <div class="col-1 mat-custom">
                            <div class="customSelect">
                                <label class="mat-form-field-label-wrapper">Valor:</label>
                                <p class="custom-info">{{ item.value | currency }}</p>
                            </div>
                        </div>
                        <div class="col-1">
                            <span class="form-text">
                                <mat-icon class="iconInfo cursorCustom"
                                    [ngClass]="item.isSuccess ? 'doneIcon' : 'errorIcon'"
                                    triggers="mouseenter:mouseleave" [autoClose]="true" placement="left"
                                    [ngbTooltip]="htmlContentTooltipErrorDescription">
                                    {{ item.isSuccess ? 'check_circle' : 'error' }}
                                </mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <loader></loader>
</mat-card>
